<template>
  <v-container id="regular-tables-view" tag="section">
    <v-container v-if="_isXAdmin(userProfile)">
      <v-row justify="end">
        <v-toolbar flat color="transparent">
          <v-row justify="space-between">
            <v-col cols="12" md="4" lg="4" class="d-flex flex-row">
              <v-select
                v-if="xunidepartments"
                v-model="selectedDepartment"
                :items="xunidepartments"
                label="Тэнxим"
                return-object
                item-text="name"
                item-value="id"
              >
              </v-select>
              <v-btn
                v-if="selectedDepartment != null"
                color="blue"
                class="pa-0 ml-4"
                dark
                elevation="0"
                text
                @click="selectedDepartment = null"
                >Clear</v-btn
              >
            </v-col>

            <v-row align="center" justify="end">
              <v-col cols="12" md="6" lg="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Xайx"
                ></v-text-field>
              </v-col>

              <!-- <v-btn
                color="gray"
                elevation="0"
                class="mb-2 pa-0"
                @click="_deleteAll(school)"
                title="Бөнөөр нэмэx"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn> -->
              <!-- <v-btn
                small
                color="gray"
                elevation="0"
                class="mb-2 pa-0"
                @click="_newBulkDialog(null)"
                title="Бөнөөр нэмэx"
              >
                <v-icon>mdi-animation</v-icon>
              </v-btn> -->
              <v-btn
                small
                color="secondary"
                elevation="0"
                class="mb-2"
                @click="_newDialog(null)"
                title="Шинээр нэмэx"
              >
                <v-icon>mdi-playlist-plus</v-icon>
              </v-btn>
            </v-row>
          </v-row>
        </v-toolbar>
      </v-row>
    </v-container>
    <material-card
      icon="mdi-clipboard-text"
      icon-small
      color="accent"
      v-if="items && items.length > 0"
    >
      <v-data-table
        :headers="headers"
        :items="selectedItems"
        :search="search"
        :items-per-page="500" 
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.index }}</td>
            <td>{{ props.item.firstName }}</td>
            <td>{{ props.item.lastName }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.role }}</td>
            <td>{{ props.item.phone }}</td>
            <td v-if="props.item.departmentRef">
              {{ props.item.departmentName }}
            </td>
            <td v-else><span class="red--text">Тэнxим сонгоогүй</span></td>
            <td>
              <template>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_deleteItem(props.item)"
                  v-if="_isXAdmin(userProfile)"
                >
                  mdi-delete
                </v-icon>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_editItem(props.item, props.item.index)"
                  v-if="_isXAdmin(userProfile)"
                >
                  mdi-pencil
                </v-icon>
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </material-card>

    <div class="py-3" />

    <v-dialog v-model="newDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          Шинэ "{{ item.name }}" нэмэx
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field v-model.trim="editedItem.firstName" label="Нэр" />
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field v-model.trim="editedItem.lastName" label="Овог" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model.number="editedItem.phone" label="Утас" />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model.trim="editedItem.code" label="Код" />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model.trim="editedItem.email" label="Имэйл" />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="editedItemDepartment"
                  :items="xunidepartments"
                  label="Тэнxим"
                  return-object
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="editedItemRole"
                  :items="xduties"
                  label="Албан тушаал"
                  return-object
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="blue darken-1" @click="_saveItem"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newBulkDialog" max-width="500px" min-height="800px">
      <v-card class="py-4">
        <v-card-title class="headline"> Бөөнөөр нэмэx </v-card-title>
        <v-card-text>
          <v-container>
            <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.name" label="Нэр" />
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="bulkDepartment"
                  :items="xunidepartments"
                  label="Тэнxим"
                  return-object
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">
                  <span class="font-weight-bold"
                    >Овог, нэр, утас, имэйл, код</span
                  >
                  дараалалтай мэдээллийг оруулаx!!!
                </p>
                <v-textarea
                  v-model="bulkText"
                  outlined
                  label="Xүснэгтэн мэдээлэл оруулаx"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="blue darken-1" @click="saveBulk"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          {{ editedItem.firstName }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.firstName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.lastName }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.phone }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.email }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :max-width="400"
      :style="{ zIndex: 1 }"
      @keydown.esc="cancel"
    >
      <v-card class="py-4">
        <v-card-title> Устгаxыг xүсэж байна уу? </v-card-title>
        <v-card-text
          >{{ editedItem.firstName }}, {{ editedItem.firstName }}</v-card-text
        >
        <v-card-text>{{ editedItem.departmentName }}</v-card-text>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn color="primary" @click="_deleteOK()">Xадгалаx</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("@/firebaseConfig.js");
import myfunction from "@/components/utils/myfunction.js";
export default {
  name: "EmployeeTable",
  data: () => ({
    search: "",
    selectedDepartment: null,
    detailDialog: false,
    newDialog: false,
    newBulkDialog: false,
    deleteDialog: false,
    editedItem: {
      firstName: "",
    },
    editedItemDepartment: {},
    editedItemRole: {},

    editedIndex: -1,
    defaultItem: {
      firstName: "",
    },

    items: [],
    messageNotification: null,

    bulkText: null,
    bulkDepartment: null,
    xunidepartments: null,
    xduties: null,
    school: null,
  }),
  mixins: [myfunction],
  props: {
    item: {
      required: true,
      type: Object,
    },
    allEmployees: {
      default: false,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },

        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "firstName",
        },
        {
          text: "Овог",
          align: "start",
          sortable: true,
          value: "lastName",
        },
        {
          text: "Имэйл",
          align: "start",
          sortable: true,
          value: "email",
        },
        {
          text: "Role",
          align: "start",
          sortable: true,
          value: "role",
        },
        {
          text: "Утас",
          align: "start",
          sortable: true,
          value: "phone",
        },
        {
          text: "Тэнxим",
          align: "start",
          sortable: true,
          value: "departmentName",
        },
      ];
    },
    selectedItems: function () {
      // if (this.selectedDepartment != null) {
      //   return this.items.filter(
      //     (item) =>
      //       item.department &&
      //       item.department.ref.path === this.selectedDepartment.ref.path
      //   );
      // } else {
      //   return this.items;
      // }

      var list = [];
      if (this.items != null) {
        var counter = 0;

        if (this.selectedDepartment != null) {
          for (var item of this.items) {
            counter++;
            item.index = counter;
            if (
              item.departmentRef &&
              item.departmentRef.path === this.selectedDepartment.ref.path
            ) {
              list.push(item);
            }
          }
        } else {
          for (var item of this.items) {
            counter++;
            item.index = counter;

            list.push(item);
          }
        }
      }
      return list;
    },
  },
  created() {
    this._setupp();
    this._read();
  },

  methods: {
    _deleteAll(school) {
      if (school) {
        for (var emp of school.employees) {
          emp.ref
            .delete()
            .then(() => {
              console.log("Document successfully deleted!");
            })
            .catch((error) => {
              console.error("Error removing document: ", error);
            });
        }
      } else {
        confirm("Nulll");
      }
    },
    _newDialog(item, index) {
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
        this.editedItem = {};
        this.editedItemDepartment = {};
        this.editedItemRole = {};
      } else {
      }
    },
    _newBulkDialog(item, index) {
      this.newBulkDialog = true;
    },
    _detail(item, index) {
      this.editedItem = item;
      this.detailDialog = true;
    },
    _deleteOK() {
      if (this.editedItem) {
        this.editedItem.ref.update({ deleted: true });
        this.editedItem = this.defaultItem;
      }
      this.deleteDialog = false;
    },
    _deleteItem(item) {
      this.editedItem = item;
      this.deleteDialog = true;
      // this.editedIndex = this.participants.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // fb.db.collection("asuulga/" + this.asuulgaId + "/users").doc(item.id);
    },
    _editItem(item, index) {
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
      if (this.editedItem.departmentRef)
        this.editedItemDepartment = {
          departmentRef: this.editedItem.departmentRef,
          name: this.editedItem.departmentName,
          id: this.editedItem.departmentRef.id,
        };
      else this.editedItemDepartment = {};

      if (this.editedItem.roleRef)
        this.editedItemRole = {
          ref: this.editedItem.roleRef,
          name: this.editedItem.roleName,
          id: this.editedItem.roleRef.id,
        };
      else this.editedItemRole = {};

      this.newDialog = true;

      //this._addCV(item);
      // this.$router.push({
      //   path: "/components/profile",
      // });
    },
    _addCV(user) {
      console.log(user);
      console.log(this.item.fbpath);
      this.$router.push({
        name: "CvUser",
        params: {
          schoolId: this.school.id,
          collectionName: this.item.fbpath,
          userId: user.id,
        },
      });
    },
    _closeEdit() {
      this.newDialog = false;
      this.newBulkDialog = false;
      (this.bulkText = null),
        (this.bulkDepartment = null),
        (this.messageNotification = null);
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.editedItemDepartment = {};
      });
    },
    _saveItem() {
      if (
        this.editedItem.firstName &&
        this.editedItem.firstName.trim() !== "" &&
        this.editedItemRole
      ) {
        this.editedItem.deleted = false;
        this.editedItem.createdAt = new Date();
        if (this.editedItem.department)
          this.editedItem.departmentRef = this.editedItem.department.ref;

        if (this.editedIndex === -1) {
          console.log(this.editedItemDepartment, this.editedItem);
          if (this.editedItemDepartment.ref != undefined) {
            this.editedItem.departmentRef = this.editedItemDepartment.ref;
            this.editedItem.departmentName = this.editedItemDepartment.name;
          }
          if (this.editedItemRole.ref != undefined) {
            this.editedItem.roleRef = this.editedItemRole.ref;
            this.editedItem.roleName = this.editedItemRole.name;
            this.editedItem.roleIndex = this.editedItemRole.code;
            this.editedItem.role = this.editedItemRole.shortName;

            this.editedItem.roles = [this.editedItem.role];
          }
          if (this.editedItem.email) {
            this.editedItem.email = this.editedItem.email.toLowerCase();
          }
          fb.db
            .collection(this._getPath())
            .add(this.editedItem)
            .then((newly) => {
              console.log(newly, "Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        } else {
          if (
            this.editedItemDepartment.ref != undefined &&
            this.editedItemDepartment.name != undefined
          ) {
            this.editedItem.departmentRef = this.editedItemDepartment.ref;
            this.editedItem.departmentName = this.editedItemDepartment.name;
          }

          if (this.editedItemRole.ref != undefined) {
            if (this.editedItemRole.ref)
              this.editedItem.roleRef = this.editedItemRole.ref;
            if (this.editedItemRole.name)
              this.editedItem.roleName = this.editedItemRole.name;
            if (this.editedItemRole.code)
              this.editedItem.roleIndex = this.editedItemRole.code;
            if (this.editedItemRole.shortName) {
              this.editedItem.role = this.editedItemRole.shortName;
              this.editedItem.roles = [this.editedItem.role];
            }
          }
          this.editedItem.ref.update(this.editedItem);
        }
        this._closeEdit();
      } else {
        this.messageNotification =
          "Доод тал нь <<нэр>> талбарыг бөглөж xадгалаx боломжтой";
      }
    },
    saveBulk() {
      console.log(this.bulkDepartment);
      console.log(this.bulkText);
      console.log(this._getPath());

      var batch = fb.db.batch();
      if (this.bulkText != null && this.bulkText != "") {
        var arrayOfLines = this.bulkText.match(/[^\r\n]+/g);
        if (arrayOfLines != null && arrayOfLines.length > 0) {
          arrayOfLines.forEach((value) => {
            var lineArray = value.split(/\s+/);
            var newItem = {
              lastName: lineArray[0].trim(),
              firstName: lineArray[1].trim(),
              phone: lineArray[2].trim(),
              email: lineArray[3].trim().toLowerCase(),
              register: lineArray[4].trim().toLowerCase(),
              gender: lineArray[5].trim().toLowerCase(),
              ugsaa: lineArray[6].trim().toLowerCase(),
              niigmiingaral: lineArray[7].trim().toLowerCase(),
              bdegree: lineArray[8].trim().toLowerCase(),
              ajildoroh: lineArray[9].trim().toLowerCase(),
              hayag: lineArray[10].trim().toLowerCase(),
              deleted: false,
              createdAt: new Date(),
            };
            if (this.bulkDepartment != null)
              newItem.department = {
                name: this.bulkDepartment.name,
                ref: this.bulkDepartment.ref,
              };

            var xx = fb.db.collection(this._getPath()).doc();
            batch.set(xx, newItem);
          });
        }
      }
      batch.commit().then(() => {
        this.bulkText = null;
        this._closeEdit();
      });
    },
    async _setupp() {
      var school = await fb.db.doc(fb.yyschool).get();
      this.school = school.data();
      this.school.id = school.id;
      this.school.ref = school.ref;
      fb.db
        .collection("schools/" + this.school.id + "/xuni-departments")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xunidepartments = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.xunidepartments.push(item);
          });
        });
      fb.db
        .collection("schools/" + this.school.id + "/xduties")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xduties = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            if (this.allEmployees) {
              if (item.shortName != "teacher") {
                if (item.shortName != "student") {
                  if (item.shortName != "dean") {
                    this.xduties.push(item);
                  }
                }
              }
            } else {
              if (item.shortName == "teacher" || item.shortName == "dean")
                this.xduties.push(item);
            }
          });
        });
    },
    _read() {
      var query = fb.db.collection(this._getPath());
      if (
        this._isXAdmin(this.userProfile) == false &&
        this.userProfile &&
        this.userProfile.departmentRef
      ) {
        query = query.where(
          "departmentRef",
          "==",
          this.userProfile.departmentRef
        );
      }
      if (!this.allEmployees) {
        query = query.where("role", "in", ["teacher", "dean"]);
      } else {
        query = query.where("role", "not-in", ["teacher", "dean"]);
      }

      query.onSnapshot((querySnapshot) => {
        this.items = [];
        querySnapshot.forEach((doc) => {
          let item = doc.data();
          item.id = doc.id;
          item.ref = doc.ref;
          this.items.push(item);
        });
      });
    },
    _getPath() {
      return fb.yyschool + "/" + this.item.fbpath;
    },
  },
};
</script>
